var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showSideNav)?_c('SideNav'):_vm._e(),_c('router-view',{staticClass:"main"}),_vm._l((_vm.$store.state.snackBar.messages),function(s,index){return _c('snack-bar',{key:index,attrs:{"index":index}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }